export const organizationLoginStyle = {
	wrapper: {
		display: 'flex',
		maxWidth: '1200px',
		padding: '0 15px',
		margin: '40px auto',

		'@media (max-width: 1199.98px)': {
			justifyContent: 'center',
		},
	},

	aside: {
		maxWidth: '473px',
		width: '100%',

		'@media (max-width: 1199.98px)': {
			display: 'none',
		},
	},

	form: {
		maxWidth: '727px',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		position: 'relative',
	},
};
